import { ref } from 'vue'
const activeItem = ref()
const useMapActiveItem = () => {
  const setActive = (num) => {
    activeItem.value = num
  }

  return { setActive, activeItem }
}

export default useMapActiveItem
